import {
    createSlice
} from '@reduxjs/toolkit';
import {
    status
} from 'nprogress';
import Swal from 'sweetalert2';
import { myroutes } from '../../routes/webroute';
import { Navigate, useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';

const navigate = useNavigate;

const initialState = {
    user: {},
    token: "",
    isAuthenticate: false, // default value
    roles: []
};

export const auth = createSlice({
    name: 'auth',
    initialState,

    reducers: {
        // authentification 
        loginUser(state, action) {
            // reset data
            state.user = null;
            state.token = "";
            state.isAuthenticate = false;
            state.roles = [];
            const loginRequest = action.payload;
            state.user = loginRequest.user;
            //console.log(loginRequest);
            state.token = loginRequest.access_token;
            state.isAuthenticate = true;
            //console.log("********** print ******")
            let item = loginRequest.roles.map((role,index) => { return role.libelle;  })
            //console.log("********** end print **********")
            state.roles = item; 
            // redirect to dashboard         
        },

        // authentification 
        resetAuthData(state) { 
            state.user = null;
            state.token = '';
            state.isAuthenticate = false;
            state.roles = [];
            //return navigate(myroutes.login)      
        },

        // authentification 
        checkAuthenticate(state) {
            //console.log(action);
            let statut = false;  
            if (state.token) {
                const decodedToken = jwtDecode(state.token);
                const currentDate = new Date().getTime() / 1000; // Convertir la date actuelle en secondes 
                if (decodedToken.exp < currentDate) {
                    // Le token a expiré
                    statut = false;
                }else{
                    statut = true
                }  
            }  

            state.isAuthenticate = statut;

            if (!statut) {
                state.user = null;
                state.token = "";
                state.isAuthenticate = false;
                state.roles = [];
            }  

            // redirect to dashboard         
        }
    },
});

export const {
    loginUser,
    checkAuthenticate,
    resetAuthData
} = auth.actions;

export default auth.reducer;